module.exports = __webpack_public_path__ + "img/f9259eee4d6a598886271d3455eb08fa.png";